/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import {
  type AnimatedIllustrativeBaseIconProps,
  AnimatedIllustrativeIcon,
} from "../animated-illustrative-icon";
import animationData from "../assets/json/404-error-duocolor-animated.json";

export const IllustrativeIcon404ErrorDuocolorAnimated = (props: AnimatedIllustrativeBaseIconProps) => (
  <AnimatedIllustrativeIcon {...props} json={animationData} />
);

IllustrativeIcon404ErrorDuocolorAnimated.displayName = "IllustrativeIcon404ErrorDuocolorAnimated";
